export default "/signup/_next/static/chunks/fonts/inter-v3-latin-regular-4b4c7761055ce14aa504f0af1e437e63.eot";